const ERROR_PROMPT = {
  default: {
    title: 'Sorry! Moxi appears to be having technical issues.',
    message: 'Please contact Diligent through iMobile using the contact MOXI',
  },
  cannotCancel: {
    title: 'Sorry! You can no longer cancel this task.',
    message: 'Item(s) will be delivered to specified destination.',
  },
  errorDuringCancel: {
    title: 'Error attempting to cancel this task.',
    message: 'Please try again.',
  },
};

export default ERROR_PROMPT;
